export enum EShortCutSurah {
  AL_MULK = 67,
  AL_KAHF = 18,
  YASIN = 36,
  YUSUF = 12,
}
